export default {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED',
};
